import './Menu.css';

import { useContext } from 'react';
import { AuthContext } from '../../contextos/authContext'
import { CONSTANTES } from '../../config/constantes'

import { servDownloadFilePorFilename } from '../../servicos/servicosEmRotasPrivadas/download';

import { Link } from 'react-router-dom'
import { servInvalidarToken } from '../../servicos/servicosEmRotasPrivadas/login';

function MenuRender({ botoesERotas }) {

    const { signed } = useContext(AuthContext);

    return (

        <div className='d-flex justify-content-center container-fluid' style={{ 'backgroundColor': '#f5f3f3' }}>
            <nav className="navbar navbar-expand-sm p-0" style={{ 'backgroundColor': '#f5f3f3' }}>
                <div className="container-fluid">
                    {signed ?
                        <Link className='navbar-brand' to='/'>Menu</Link>
                        :
                        <Link className='navbar-brand' to='https://web2.smsrio.org/'>Menu</Link>
                    }
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            {botoesERotas.map((menu) =>
                                <li key={menu.id} className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        {menu.nome}
                                    </a>
                                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown" style={{ 'backgroundColor': '#f5f3f3' }}>
                                        {menu.submenus.map((submenu) =>
                                            submenu.linkExterno ?
                                                <li key={submenu.id}>
                                                    <button
                                                        className="dropdown-item"
                                                        type="button"
                                                        onClick={() => servDownloadFilePorFilename(CONSTANTES.FILENAME_FICHA_INDICADORES)}
                                                    >
                                                        {submenu.submenu}
                                                    </button>
                                                </li>
                                                :
                                                <li key={submenu.id}>
                                                    <Link className='dropdown-item' to={submenu.linkTo}>{submenu.submenu}</Link>
                                                </li>
                                        )}
                                    </ul>
                                </li>
                            )}
                            {signed &&
                                <>
                                    <li className="nav-item">
                                        <button
                                            className="nav-link"
                                            type="button"
                                            onClick={() => servDownloadFilePorFilename(CONSTANTES.FILENAME_MANUAL_DO_SISTEMA)}
                                        >
                                            Manual de Uso
                                        </button>
                                    </li>

                                    {process.env.REACT_APP_BUTTON_LIMPA_CACHE === "true" && (
                                        <li className="nav-item">
                                            <button
                                                className="nav-link"
                                                type="button"
                                                onClick={() => servInvalidarToken()}
                                            >
                                                Limp Info Login
                                            </button>
                                        </li>
                                    )}
                                </>
                            }
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default MenuRender;
